{
  "title": "Cone of Cold",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level evocation",
  "level": 5,
  "castingTime": "1 action",
  "range": "Self (60-foot cone)",
  "components": "V, S, M (a small crystal or glass cone)",
  "duration": "Instantaneous",
  "description": [
    "A blast of cold air erupts from your hands. Each creature in a 60-foot cone must make a Constitution saving throw. A creature takes 8d8 cold damage on a failed save, or half as much damage on a successful one. A creature killed by this spell becomes a frozen statue until it thaws.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, the damage increases by 1d8 for each slot level above 5th."
  ],
  "spellLists": ["druid", "sorcerer", "wizard"]
}
